import React, { useEffect, useState } from 'react';
import { Calendar, Clock, Video, DollarSign } from 'lucide-react';
import { Button } from './ui/button';
import { trackAdsConversion, ADS_CONVERSION_LEAD } from '../mock';

// Calendly URL del estudio
const CALENDLY_URL = 'https://calendly.com/sampellegrini-jaliff';

const CalendlySection = () => {
  const [jusOpen, setJusOpen] = useState(false);
  useEffect(() => {
    // Load Calendly widget script
    const head = document.querySelector('head');
    const existing = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
    if (!existing) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      head.appendChild(script);

      const link = document.createElement('link');
      link.href = 'https://assets.calendly.com/assets/external/widget.css';
      link.rel = 'stylesheet';
      head.appendChild(link);
    }

    // Calendly postMessage: fire Ads conversion only when a booking is confirmed
    const onMessage = (e) => {
      if (e.origin !== 'https://calendly.com') return;
      if (e.data && e.data.event === 'calendly.event_scheduled') {
        trackAdsConversion(ADS_CONVERSION_LEAD);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
      return false;
    }
    window.open(CALENDLY_URL, '_blank');
  };

  return (
    <section className="calendly-section" id="turnos" data-testid="calendly-section">
      <div className="calendly-container">
        <div className="calendly-content">
          <p className="calendly-eyebrow">AGENDÁ TU CONSULTA</p>
          <h2 className="calendly-title">Reservá una reunión sin moverte de tu casa.</h2>
          <p className="calendly-subtitle">
            Elegí el día y horario que mejor te quede. Coordinamos una primera consulta 
            para escucharte y entender tu situación. Te escuchamos y te decimos cómo seguir.
          </p>

          <div className="calendly-features">
            <div className="calendly-feature">
              <div className="calendly-feature-icon">
                <Calendar className="w-5 h-5" />
              </div>
              <div className="calendly-feature-text">
                <h4>Elegí el día</h4>
                <p>Disponibilidad real en tiempo real</p>
              </div>
            </div>
            <div className="calendly-feature">
              <div className="calendly-feature-icon">
                <Clock className="w-5 h-5" />
              </div>
              <div className="calendly-feature-text">
                <h4>1 hora</h4>
                <p>O el tiempo suficiente para evacuar todas las dudas que tengas</p>
              </div>
            </div>
            <div className="calendly-feature">
              <div className="calendly-feature-icon">
                <Video className="w-5 h-5" />
              </div>
              <div className="calendly-feature-text">
                <h4>Online o presencial</h4>
                <p>Vos elegís la modalidad</p>
              </div>
            </div>
            <div className="calendly-feature">
              <div className="calendly-feature-icon">
                <DollarSign className="w-5 h-5" />
              </div>
              <div className="calendly-feature-text">
                <h4>Consulta arancelada</h4>
                <p>1 Jus honorario<br /><span className="ius-value">según valor arancelario vigente fijado por el Colegio de Abogados</span></p>
              </div>
            </div>
          </div>

          <div className={`jus-explanation ${jusOpen ? 'jus-open' : ''}`} data-testid="jus-explanation">
            <h3 className="jus-explanation-title">¿Por qué la primera consulta tiene un valor?</h3>
            <p className="jus-summary" data-testid="jus-summary">
              Consulta de hasta 1 hora · 1 Jus · se descuenta del presupuesto si avanzamos
            </p>
            <button
              type="button"
              className="jus-toggle"
              onClick={() => setJusOpen((v) => !v)}
              aria-expanded={jusOpen}
              data-testid="jus-toggle"
            >
              {jusOpen ? 'Leer menos' : 'Leer más'}
            </button>
            <div className="jus-full">
            <p className="jus-explanation-text">
              Porque no es una consulta de pasillo: es una reunión profesional de hasta 1 hora
              donde hacemos un <strong>análisis minucioso de tu documentación</strong>, evaluamos la
              <strong> viabilidad real</strong> de tu caso y te planteamos una
              <strong> estrategia inicial concreta</strong>, con abogadas matriculadas y reserva ética.
            </p>
            <p className="jus-explanation-text">
              El valor del <strong>Jus</strong> no es un monto arbitrario: es el honorario mínimo
              obligatorio estipulado por la <em>Ley Arancelaria 14.967</em> para garantizar un
              asesoramiento profesional, profundo y responsable. Si decidimos avanzar juntos,
              ese valor se descuenta del presupuesto que acordemos.
            </p>
            </div>
          </div>

          <Button
            onClick={openCalendly}
            className="calendly-cta-btn"
            size="lg"
            data-testid="calendly-cta-button"
          >
            <Calendar className="w-5 h-5 mr-2" />
            Agendar consulta ahora
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CalendlySection;
